'use client';

import { PlayedMatch, PlayedMatchesListBase } from '@/components/molecules/tie-breaker/PlayedMatchesListBase';

interface ResponsivePlayedMatchesListProps {
	playedMatches: PlayedMatch[];
	isMatchOverAndCompleted: boolean;
	editScores: boolean;
	setEditScores: React.Dispatch<React.SetStateAction<boolean>>;
	updatePlayedTieBreakerSequences: (updated: PlayedMatch[]) => void;
	isEditing: boolean;
	isUpdatingSequence: boolean;
	isPublicMatchResultPage?: boolean;
	canUserEditScores: boolean;
	canEditCompletedSequences?: boolean;
}

export const ResponsivePlayedMatchesList = (props: ResponsivePlayedMatchesListProps) => {
	return (
		<>
			<div className="sm:hidden">
				<PlayedMatchesListBase {...props} isMobile />
			</div>

			<div className="hidden sm:block">
				<PlayedMatchesListBase {...props} isMobile={false} />
			</div>
		</>
	);
};
